import * as Yup from 'yup'

export const AuthCodeSchema = Yup.object({ code: Yup.string().required().min(6).max(6).default('') }).required()
export const BackupCodeSchema = Yup.object({ code: Yup.string().required().min(8).max(8).default('') }).required()
